import { render } from "./houseIndivid.vue?vue&type=template&id=b1bbc620&scoped=true"
import script from "./houseIndivid.vue?vue&type=script&lang=js"
export * from "./houseIndivid.vue?vue&type=script&lang=js"

import "./houseIndivid.vue?vue&type=style&index=0&id=b1bbc620&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1bbc620"]])

export default __exports__